module.exports = __webpack_public_path__ + "static/media/marine-buoy.34f85a1b.svg";